import get from 'lodash/get';

import {
    getBuiltSurvey,
    shouldIncludeInBuyerQuestions,
    shouldIncludeInBasicInfo,
    shouldIncludeInAttendeeQuestions,
} from '../models/survey';

import { createSelector } from './utils/selector';

import { LOCALIZED_QUESTIONS_CHOICES_BY_QUESTION_ID } from '../models/survey';
import { gettext } from '../translations';

const getQuestionsCollection = (state) =>
    get(state, 'survey.questionsCollection');
export const getInteractiveQuestions = (state) =>
    get(state, 'survey.interactiveQuestions');

export const _shouldGetChoicesText = (choices, questionId) =>
    LOCALIZED_QUESTIONS_CHOICES_BY_QUESTION_ID[questionId]
        ? LOCALIZED_QUESTIONS_CHOICES_BY_QUESTION_ID[questionId]
        : choices;

const ticketNumberText = (ticketNumber) =>
    gettext('Ticket %(ticketNumber)s', { ticketNumber });

const _getAttendeeSurveyTitleText = (ticketNumber, ticketClassName) =>
    `${ticketNumberText(ticketNumber)} · ${ticketClassName}`;

export const getCountries = (state) => get(state, 'address.countries', {});

export const _buildAttendeeSurveys = (
    attendees = [],
    questions,
    shouldIncludeQuestionHelper,
) =>
    attendees.reduce(
        (attendeeSurvey, { id, survey = [], ticketClassName }, index) => {
            if (survey.length > 0) {
                attendeeSurvey.push({
                    id,
                    survey: getBuiltSurvey(
                        questions,
                        survey,
                        shouldIncludeQuestionHelper,
                    ),
                    ticketClassName,
                    ticketNumber: index + 1,
                });
            }

            return attendeeSurvey;
        },
        [],
    );

// Return questionsForBasicInfo
export const getQuestionsForBasicInfo = createSelector(
    (state) => getQuestionsCollection(state),
    (state) => getInteractiveQuestions(state),
    (questionsCollection, interactiveQuestions) =>
        getBuiltSurvey(
            questionsCollection,
            interactiveQuestions,
            shouldIncludeInBasicInfo,
        ),
);

// Return questionsForAttendees object
export const getQuestionsForAttendees = createSelector(
    (state) => get(state, 'order.attendees'),
    (state) => getQuestionsCollection(state),
    (attendees, questionsCollection) =>
        _buildAttendeeSurveys(
            attendees,
            questionsCollection,
            shouldIncludeInAttendeeQuestions,
        ),
);

// Return questionsForBuyer object
export const getQuestionsForBuyer = createSelector(
    (state) => getQuestionsCollection(state),
    (state) => getInteractiveQuestions(state),
    (state) => get(state, 'order.taxIdName'),
    (questions, survey, taxIdName) =>
        getBuiltSurvey(
            questions,
            survey,
            shouldIncludeInBuyerQuestions,
            taxIdName,
        ),
);

export const getSurvey = (state) => ({
    questionsForAttendees: getQuestionsForAttendees(state),
    questionsForBuyer: getQuestionsForBuyer(state),
    questionsForBasicInfo: getQuestionsForBasicInfo(state),
});

export const getAttendeesSelectorOptions = createSelector(
    (state) => get(state, 'order.attendees'),
    getQuestionsForAttendees,
    (attendees, attendeeSurvey) =>
        attendeeSurvey.map(({ id, ticketClassName }) => {
            const ticketIndex = attendees.findIndex(
                ({ id: attendeeId }) => id === attendeeId,
            );

            return {
                value: id,
                display: _getAttendeeSurveyTitleText(
                    ticketIndex + 1,
                    ticketClassName,
                ),
            };
        }),
);
